import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NewsletterComponent } from '../../shared/components/newsletter/newsletter.component';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [RouterLink, NewsletterComponent],
  templateUrl: './about.component.html',
  styleUrl: './about.component.css'
})
export class AboutComponent {
 
}
